export function PageHeader({ title, subtitle, action, testid }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-8 fade-up" data-testid={testid}>
      <div>
        <h1 className="font-display text-2xl md:text-3xl font-black tracking-tight">{title}</h1>
        {subtitle && <p className="text-[#94A3B8] text-sm mt-1.5 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
